import React, { Component } from 'react';
import superagent from 'superagent';
import ReactLoading from 'react-loading';
import {NavLink, Link} from 'react-router-dom';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';



class Transcripts extends Component {
    constructor(props)
    {
        super(props);

        this.fetchTranscript = this.fetchTranscript.bind(this);
        this.generatePDF = this.generatePDF.bind(this);
        this.updateYear = this.updateYear.bind(this);


        this.state = {
            user_details:this.props.user_details,
            access_token:this.props.access_token,
            transcript:[],
            grading:[],
            symbols:[],
            selectedYear: 0,
            averageGrade: null,
            api_loading:false,
            api_loading_message:"",
            loading:false,
            loaded_successfully:false,
            api_error_message:"",
            mode:0,
            server_changes_made:false

        }
    }


    updateYear(event)
      {
          this.setState({selectedYear:event.target.value, server_changes_made:false});
      }


  generatePDF()
  {
    const input = document.getElementById('slip');

    html2canvas(input)
    .then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        pdf.addImage(imgData, 'PNG', 0, 0);
        pdf.save("slip1.pdf");
      });

  }


  fetchTranscript()
  {

            this.setState({loading:true});
            let _this = this;

            const url = this.props.base_url +"/student/transcript";

            superagent
            .post(url)
            .send({admission_number:_this.props.student_details.core_details.AdmnNo,
                    year:"YEAR " + _this.state.selectedYear,
                    grade_type:_this.props.student_details.programme_details.GradeType})
            .set('Accept', 'application/json')
            .set('Content-Type', 'application/json')
            .then(function(res){
                //res.body, res.headers, res.status
                let error = res.body.error;
                console.log("Response", res.body);


                if(!error)
                {
                    console.log("Process", "successful loading");

                    _this.setState({grading:res.body.grading, symbols:res.body.symbols,  transcript:res.body.transcript, averageGrade: res.body.averageGrade, loading:false, loaded_successfully:true, api_error_message:"",server_changes_made:true});

                }
                else
                {
                    _this.setState({loading:false, transcript:[], symbols:[], averageGrade: null, grading:[], loaded_successfully:false, api_error_message:res.body.message, server_changes_made:true});
                }

            })
            .catch(function(err){

                console.log("error response", err);
                _this.setState({loading:false, transcript:[], symbols:[], averageGrade: null, grading:[],  loaded_successfully:false, api_error_message:err,server_changes_made:true});
            });

  }





  renderErrorMessage()
  {
    const _this = this;

      if(this.state.authentication_error && !this.state.loading)
      {
          return(
            <div className="loading-progress">
                <div className="error-message">
                    <p>{_this.state.api_error_message}</p>
                </div>
            </div>
          );
      }
      else
      {
        return null;
      }

  }

  renderLoadingProgress()
  {
    const _this = this;
      if(this.state.api_loading)
      {
          return(
            <div className="loading-progress">
            <div >
                {_this.state.api_loading_message}
                <ReactLoading className="loading-progress" type="spinningBubbles" color="#000" height="40"  />
            </div>
        </div>

          );
      }
      else{
          return null;
      }
  }

  renderTranscriptPeriod()
  {
    const _this = this;
      if(_this.state.selectedYear != 0 && _this.state.server_changes_made)
      {
          return(
            <span className= "transcript-period">
                ( Year : {_this.state.selectedYear} Sem :  {_this.state.selectedSemester} )
            </span>

          );
      }
      else{
          return null;
      }
  }

  renderDownloadButton()
  {
    const _this = this;
      if(_this.state.transcript.length > 0 &&  _this.state.server_changes_made)
      {
          return(
                <button className="btn btn-primary btn-round" onClick={_this.generatePDF.bind(_this)} >Download<div className="ripple-container"></div></button>

          );
      }
      else{
          return null;
      }
  }

  renderButtons()
  {
    const _this = this;
      if(_this.state.transcript.length > 0 &&  _this.state.server_changes_made)
      {
          return(
              <div>
                <img width="30" height="30" onClick={_this.generatePDF.bind(_this)} />
                <img width="30" height="30" onClick={_this.generatePDF.bind(_this)} />
              </div>

          );
      }
      else{
          return null;
      }
  }

  renderTranscript()
  {
    const _this = this;

    if(this.state.selectedYear == 0 || this.state.selectedSemester == 0 ||  ! this.state.server_changes_made)
    {
      return(<p className="full-width text-center" style = {{paddingTop:'15px', paddingBottom:'15px'}}> Select Year then click the Submit button to view Transcript </p>);
    }
    else  if (this.state.selectedYear != 0 && this.state.transcript.length > 0)
    {
      let transcript_list = _this.state.transcript.map(unit =>
          {
            console.log(unit);
            return (
                <tr>
                    <td>
                          {unit.code}
                    </td>
                      <td>
                          {unit.title}
                      </td>
                      <td>
                          {unit.marks}
                      </td>
                      <td>
                          {unit.grade}
                      </td>
                  </tr>
                      );
          });

          return (
            <table className="table" id = "slip">

                <thead>
                    <tr>

                        <th style ={{fontWeight:"bold"}}>CODE</th>
                        <th style ={{fontWeight:"bold"}}>NAME</th>
                        <th style ={{fontWeight:"bold"}}>MARKS</th>
                        <th style ={{fontWeight:"bold"}}>GRADE</th>
                    </tr>
                    </thead>

                <tbody>

                    {transcript_list}

                </tbody>
            </table>
          );
    }
    else {
      return (<p className="text-center full-width" style = {{color:"red"}}> { this.state.api_error_message }</p> );
    }


  }

  renderGrading()
  {
    const _this = this;

    if((this.state.transcript.length > 0 && this.state.grading.length > 0) && (this.state.selectedYear != 0 && this.state.selectedSemester != 0 && this.state.server_changes_made) )
    {
      let grading_list = _this.state.grading.map(grade =>
          {
          console.log(grade);
          return (
              <tr>
                  <td>
                      {grade.Range}
                  </td>
                  <td>
                      {grade.Names}
                  </td>
              </tr>
                  );
          });

          return (
            <div className="col-lg-4 col-md-6 col-sm-8 col-xs-10 grading">
                    <h4 className = "inner-title">GRADING</h4>

                    <table className="table">

                            <thead className="text-warning">
                                <tr>

                                    <th>Range</th>
                                    <th>Grade</th>
                                </tr>
                            </thead>
                            <tbody>
                            {grading_list}
                            </tbody>
                    </table>

            </div>
          );
    }


  }

  renderSymbols()
  {
    const _this = this;

    if((this.state.transcript.length > 0 && this.state.symbols.length > 0) && (this.state.selectedYear != 0 && this.state.selectedSemester != 0 && this.state.server_changes_made) )
    {
      let symbol_list = _this.state.symbols.map(symbol =>
          {
          return (
              <tr>
                  <td>
                      {symbol.Symbol}
                  </td>
                  <td>
                      {symbol.Names}
                  </td>
              </tr>
                  );
          });

          return (
            <div className="col-lg-4 col-md-6 col-sm-8 col-xs-10 grading" style={{float:"right"}}>
                    <h4 className = "inner-title">Symbols</h4>

                    <table className="table">

                            <thead className="text-warning">
                                <tr>

                                    <th>Symbol</th>
                                    <th>Meaning</th>
                                </tr>
                            </thead>
                            <tbody>
                              {symbol_list}
                            </tbody>
                    </table>

            </div>
          );
    }


  }

  render() {

    const _this=this;
    let transcript_list;
    let grading_list;
    let main_content;


    if(this.state.loading)
    {
        return(
            <div >
                    Loading, Please wait......
                    <ReactLoading className="loading-progress" type="bars" color="#000" height="100px" width="120px"  />
                </div>
        );
    }

    return (
            <div className=" full-width">
                    <div className="col-lg-12 col-md-12">
                        <div className="card full-width">
                            <div className="card-body">
                                <div className="tab-content block-centered">
                                    <div className="tab-pane active" id="profile">
                                        <h4 className ="text-center" style ={{fontWeight:"style"}}>TRANSCRIPT   {_this.renderTranscriptPeriod()} {_this.renderDownloadButton()} </h4>

                                        <div className="row full-width block-centered col-lg-8">
                                            <div className="col-lg-6 justified text-center">
                                                YEAR :
                                                <select type="select" value={_this.state.selectedYear} className="select-box" onChange = {this.updateYear.bind(_this)}>
                                                  <option value="0">Select Year</option>
                                                  <option value="1">1</option>
                                                  <option value="2">2</option>
                                                  <option value="3">3</option>
                                                  <option value="4">4</option>
                                                  <option value="5">5</option>
                                                  <option value="6">6</option>
                                                </select>
                                            </div>

                                            <div className="col-lg-4 block-centered">
                                                <button className="btn btn-primary btn-round" type="submit" style ={{marginTop:'20px'}} onClick={_this.fetchTranscript.bind(_this)} disabled={_this.state.selectedYear == 0 || _this.state.selectedSemester == 0} >Submit<div className="ripple-container"></div></button>
                                            </div>
                                        </div>
                                        {_this.renderTranscript()}

                                        <div className = "row block-centered full-width col-lg-12 col-md-12">
                                          {_this.renderGrading()}
                                          {_this.renderSymbols()}
                                        </div>




                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

            </div>





    );
  }
}

export default Transcripts;
